import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import EntityTypes from '../../../types/EntityTypes';
export default {
  html: _defineProperty({}, EntityTypes.NOTELINK, function (_ref, _ref2) {
    var node = _ref.node,
        attributes = _ref.attributes,
        children = _ref.children;
    var _ref2$getFullNotePath = _ref2.getFullNotePath,
        getFullNotePath = _ref2$getFullNotePath === void 0 ? function (x) {
      return x;
    } : _ref2$getFullNotePath;
    var noteId = node.getIn(['data', 'nodeId']);
    return React.createElement("a", Object.assign({}, attributes, {
      href: getFullNotePath(noteId)
    }), children);
  }),
  markdown: _defineProperty({}, EntityTypes.NOTELINK, function (_ref3) {
    var node = _ref3.node,
        children = _ref3.children,
        getFullNotePath = _ref3.getFullNotePath;
    var noteId = node.getIn(['data', 'noteId']);
    var url = getFullNotePath(noteId);
    return "[".concat(children, "](").concat(url, ")");
  })
};